import type { HTMLAttributes } from 'react'

import { ExportContacts } from '../../../../components/organisms/ExportContacts'
import { CONSTS } from '../../../../config/objectConst'
import css from './NotExistYet.module.css'

export const NotExistYet = ({
	onOpen,
	...props
}: HTMLAttributes<HTMLElement> & {
	onOpen: () => void
}) => (
	<article className={css.root} {...props}>
		<h1 className={css.headline}>
			5 minutes guide on how to&nbsp;launch your first campaign
		</h1>

		<iframe
			allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share; allowfullscreen'
			// @ts-expect-error
			allowfullscreen='allowfullscreen'
			className={css.video}
			frameBorder={0}
			height={400}
			referrerPolicy='strict-origin-when-cross-origin'
			src={CONSTS.ON_BOARDING.INTRODUCTION_VIDEO.URL}
			title='YouTube video player'
			width={712}
		/>

		<ExportContacts />
	</article>
)
